import React from 'react';
import PropTypes from 'prop-types';
import './EventCard.css'; // assuming you want to keep styles in a separate css file

const gradients = {
  green: 'linear-gradient(0deg, #0f291e, #1b543a)',
  purple: 'linear-gradient(0deg, #301a3a, #5f2d84)',
  blue: 'linear-gradient(0deg, #0a1f3f, #17488f)',
  red: 'linear-gradient(0deg, #3e0b0b, #7f1c1c)'
};

const textColors = {
  green: '#a8d5a6',
  purple: '#c5a3d1',
  blue: '#a3c2f1',
  red: '#f0a1a1'
};

const EventCard = ({ title, text, content, bottomLeft, bottomRight, color = 'green' }) => {
  const gradientBackground = gradients[color] || gradients['green'];
  const textColor = textColors[color] || textColors['green'];

  return (
    <div className={`${color} event-card`} style={{ background: gradientBackground, color: textColor}}>
      <div className="event-card-header">
        <div className="event-card-title">
          {title}
        </div>
        <div className="event-card-dropdown" style={{background: 'rgba(0, 0, 0, 0.3)', borderRadius: '50%',padding: '4px 8px'}}>
          {/* This dropdown can be used for additional controls or display */}
          ▼
        </div>
      </div>
      <div className="event-card-text">
        {text}
      </div>
      <div className="event-card-content">
        {content}
      </div>
      <div className="event-card-bottom">
        <div className="event-card-bottom-left">
          {bottomLeft}
        </div>
        <div className="event-card-bottom-right">
          {bottomRight}
        </div>
      </div>
    </div>
  );
};

EventCard.propTypes = {
  title: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  content: PropTypes.node,
  bottomLeft: PropTypes.node,
  bottomRight: PropTypes.node,
  color: PropTypes.string
};

export default EventCard;


